<template>
  <el-dialog
    title="经销商绑定"
    :visible.sync="localVisible"
    width="880px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div class="agent-info-bar">
      <span>代理商：</span>
      <span class="agent-info-name">{{ agentRow ? agentRow.agencyName : '—' }}</span>
      <span class="agent-info-id">（{{ agentRow ? agentRow.agencyId : '—' }}）</span>
    </div>

    <avue-crud
      :option="tableOption"
      :data="tableData"
      :table-loading="tableLoading"
      :page.sync="page"
      ref="crud"
      @search-change="searchChange"
      @refresh-change="refreshChange"
      @size-change="pageSizeChange"
      @current-change="pageChange"
    >
      <template slot-scope="scope" slot="menuLeft">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          plain
          v-if="permission.JOINS_SALES_CLOUD_SAFETY_GUARD_DEALER_BIND_ADD"
          :disabled="!agentRow || !agentRow.id"
          @click.stop="openAddDialog()"
        >添加绑定</el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="danger"
          icon="el-icon-unlock"
          size="small"
          plain
          v-if="permission.JOINS_SALES_CLOUD_SAFETY_GUARD_DEALER_BIND_DEL"
          @click.stop="handleUnbind(scope.row)"
        >解绑</el-button>
      </template>
    </avue-crud>

    <el-dialog
      title="添加绑定"
      :visible.sync="addDialogVisible"
      width="420px"
      :close-on-click-modal="false"
      append-to-body
      @closed="resetAddForm"
    >
      <el-form :model="addForm" label-width="100px">
        <el-form-item label="代理商">
          <span>{{ agentRow ? agentRow.agencyName + '（' + agentRow.agencyId + '）' : '请先选择代理商' }}</span>
        </el-form-item>
        <el-form-item label="商户手机号" required>
          <el-input
            v-model="addForm.shopMobile"
            placeholder="请输入11位手机号"
            maxlength="11"
            style="width: 240px"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户名称">
          <el-input
            v-model="addForm.shopName"
            placeholder="输入手机号后自动识别"
            disabled
            style="width: 240px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="!addForm.shopId"
          :loading="addSubmitting"
          @click="submitBind"
        >确 定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { safetyGuardDealerBindOption } from '@/const/salesCloud/safetyGuardDealerBindOption';
import {
  bindDealers,
  findDealerBindPage,
  unbindDealer
} from '@/api/salesCloud/safetyGuard/dealerBind';
import { v1BindingDetermine } from '@/api/salesCloud/orderShopAgent/shop';

const SAFETY_DEALER_BIND_ERR_MSG = {
  '24026005': '代理商不存在或已删除',
  '24026006': '该商户已绑定安全卫士代理商'
};

export default {
  name: 'DealerBindDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    agentRow: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      tableOption: safetyGuardDealerBindOption,
      tableData: [],
      tableLoading: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      localVisible: this.visible,
      addDialogVisible: false,
      addSubmitting: false,
      addForm: {
        shopMobile: '',
        shopName: '',
        shopId: ''
      }
    };
  },
  watch: {
    visible: {
      handler(newVal, oldVal) {
        this.localVisible = newVal;
        if (newVal) {
          this.page = { total: 0, currentPage: 1, pageSize: 10 };
          this.tableData = [];
          this.handleList();
        } else if (oldVal) {
          this.tableData = [];
          this.page = { total: 0, currentPage: 1, pageSize: 10 };
        }
      }
    },
    'addForm.shopMobile'(val) {
      if (val && val.length === 11 && /^\d+$/.test(val)) {
        this.lookupShop(val);
      } else {
        this.addForm.shopName = '';
        this.addForm.shopId = '';
      }
    }
  },
  computed: {
    ...mapGetters(['permission'])
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
    showErr(res) {
      this.$message({
        showClose: true,
        message: SAFETY_DEALER_BIND_ERR_MSG[res && res.code] || (res && res.message) || '操作失败',
        type: 'error'
      });
    },
    handleList() {
      if (!this.agentRow || !this.agentRow.id) {
        this.tableData = [];
        this.page.total = 0;
        return;
      }
      this.tableLoading = true;
      const params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findDealerBindPage(this.agentRow.id, params).then(res => {
        const data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      if (!this.agentRow || !this.agentRow.id) return;
      this.tableLoading = true;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findDealerBindPage(this.agentRow.id, params).then(res => {
        const data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    pageSizeChange(pageSize) {
      if (!this.agentRow || !this.agentRow.id) return;
      this.tableLoading = true;
      const params = this.$refs.crud.searchForm || {};
      params.page = this.page.currentPage;
      params.size = pageSize;
      findDealerBindPage(this.agentRow.id, params).then(res => {
        const data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      if (!this.agentRow || !this.agentRow.id) return;
      this.tableLoading = true;
      const params = this.$refs.crud.searchForm || {};
      params.page = page;
      params.size = this.page.pageSize;
      findDealerBindPage(this.agentRow.id, params).then(res => {
        const data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      if (!this.agentRow || !this.agentRow.id) return;
      this.tableLoading = true;
      const params = this.$refs.crud.searchForm || {};
      params.page = page.currentPage;
      params.size = page.pageSize;
      findDealerBindPage(this.agentRow.id, params).then(res => {
        const data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    openAddDialog() {
      this.addDialogVisible = true;
    },
    resetAddForm() {
      this.addForm = { shopMobile: '', shopName: '', shopId: '' };
      this.addSubmitting = false;
    },
    lookupShop(mobile) {
      v1BindingDetermine({ mobile: mobile }).then(res => {
        if (res && res.data) {
          const data = JSON.parse(res.data);
          this.addForm.shopName = data.shopName || '';
          this.addForm.shopId = data.shopId || data.id || '';
          if (!this.addForm.shopId) {
            this.$message({
              showClose: true,
              message: '识别商户成功，但未返回 shopId，请联系后端确认接口字段',
              type: 'warning'
            });
          }
        } else {
          this.addForm.shopName = '';
          this.addForm.shopId = '';
          this.$message({
            showClose: true,
            message: '当前手机号暂未注册店铺',
            type: 'warning'
          });
        }
      }).catch(() => {
        this.addForm.shopName = '';
        this.addForm.shopId = '';
      });
    },
    submitBind() {
      if (!this.agentRow || !this.agentRow.id) {
        this.$message({
          showClose: true,
          message: '请先选择代理商',
          type: 'error'
        });
        return;
      }
      if (!this.addForm.shopId || !this.addForm.shopMobile) {
        this.$message({
          showClose: true,
          message: '请输入正确的商户手机号',
          type: 'error'
        });
        return;
      }
      this.addSubmitting = true;
      const payload = [{
        shopId: this.addForm.shopId,
        safetyAgentId: this.agentRow.id,
        shopMobile: this.addForm.shopMobile,
        shopName: this.addForm.shopName
      }];
      bindDealers(payload).then(res => {
        this.addSubmitting = false;
        if (res && res.code == '200') {
          this.$message({
            showClose: true,
            message: '绑定成功',
            type: 'success'
          });
          this.addDialogVisible = false;
          this.handleList();
        } else {
          this.showErr(res);
        }
      }).catch(err => {
        this.addSubmitting = false;
        this.$message({
          showClose: true,
          message: (err && err.message) || '请求失败',
          type: 'error'
        });
      });
    },
    handleUnbind(row) {
      this.$confirm('是否确认解绑该经销商？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        unbindDealer(row.id).then(res => {
          if (res && res.code == '200') {
            this.$message({
              showClose: true,
              message: '解绑成功',
              type: 'success'
            });
            this.handleList();
          } else {
            this.showErr(res);
          }
        }).catch(err => {
          this.$message({
            showClose: true,
            message: (err && err.message) || '请求失败',
            type: 'error'
          });
        });
      }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.agent-info-bar {
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  color: #606266;
  font-size: 13px;
}
.agent-info-name {
  color: #303133;
  font-weight: 600;
  margin: 0 4px;
}
.agent-info-id {
  color: #909399;
  font-size: 12px;
}
</style>
